// Internal dependencies
const {
    generateBackgroundAttributes,
    // generateBorderAttributes,
    generateResBoxControlAttributes,
    generateResRangeAttributes,
    generateTypographyAttributes
} = window.progressmatifyModules;

// constants
import { IMAX_WIDTH, GL_GAP, G_TYPO, N_TYPO, G_MARGIN, S_HEIGHT, T_TYPO, NU_TYPO, F_BG, B_BG, G_RADIUS, FG_RADIUS } from './constants';

const attributes = {
    progressmatify: {
        type: 'number',
        default: 50
    },
    label: {
        type: 'string',
        default: 'Progressmatify Bar'
    },
    titleColor: {
        type: 'string'
    },
    progessbarShow: {
        type: 'boolean',
        default: true
    },
    textColor: {
        type: 'string'
    },
    perCentange: {
        type: 'string'
    },

    link: {
        type: 'object',
        default: {
            url: '#',
            openInNewTab: false,
            addNoFollow: false,
            addSponsored: false
        }
    },
    showIcon: {
        type: 'boolean',
        default: false
    },
    sourceType: {
        type: 'string',
        default: 'library'
    },
    icon: {
        type: 'string',
        default: 'arrow-right'
    },
    customIcon: {
        type: 'string'
    },
    iconPos: {
        type: 'string',
        default: 'icon_right'
    },

    // style
    aff_btnSizeType: {
        type: 'string',
        default: 'auto'
    },
    aff_labelColors: {
        type: 'object',
        default: {
            normal: '',
            hover: ''
        }
    },
    isVisible: {
        type: 'boolean'
    },
    aff_iconColors: {
        type: 'object',
        default: {
            normal: '',
            hover: ''
        }
    },
    // Generator

    //glaobal section
    ...generateResRangeAttributes({
        controlName: IMAX_WIDTH
    }),
    ...generateResRangeAttributes({
        controlName: GL_GAP
    }),
    ...generateTypographyAttributes({
        controlName: G_TYPO
    }),
    ...generateTypographyAttributes({
        controlName: N_TYPO
    }),
    ...generateResBoxControlAttributes({
        controlName: G_MARGIN
    }),
    ...generateResRangeAttributes({
        controlName: S_HEIGHT
    }),
    ...generateTypographyAttributes({
        controlName: T_TYPO
    }),
    ...generateTypographyAttributes({
        controlName: NU_TYPO
    }),
    ...generateBackgroundAttributes({
        controlName: F_BG
    }),
    ...generateBackgroundAttributes({
        controlName: B_BG
    }),
    ...generateResBoxControlAttributes({
        controlName: G_RADIUS
    }),
    ...generateResBoxControlAttributes({
        controlName: FG_RADIUS
    })
};

export default attributes;
